import * as climate from "./mexico-climate.json"
import * as states from "./mexico-states.json"


export const mexicoClimate = climate.default;
export const mexicoStates = states.default;
export const mexicoTerrain = JSON.parse(JSON.stringify(states.default));

